import React from "react";
import contentfulTutorialsFactory, {
	fetchProps,
} from "@insightfulscience/contentful/Apps/Tutorials";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { useLocale } from "@insightfulscience/smart-react/i18";
import SectionTryForFree from "../../SectionTryForFree";
import SiteLayout from "../../SiteLayout";
import Page from "../../contentful/Apps/Tutorials/Page";
import resources from "../../../locales";
import { contentfulProps } from "../../config";

const tutorialsLayout = ({ children }) => {
	const [t] = useLocale("tutorials");
	return (
		<SiteLayout>
			<PageMeta>
				<PageMeta.Twitter image={t("META_TWITTER_IMAGE")} isImageBaseUrl />
			</PageMeta>
			{children}
			<SectionTryForFree />
		</SiteLayout>
	);
};

const ContenfulTutorialsApp = contentfulTutorialsFactory({
	Layout: tutorialsLayout,
	Page,
	contentfulProps,
	pageProps: {
		resources,
		brandCode: "gn",
		siteDomain: "https://www.geneious.com",
	},
	mode: "isr",
});

export const getStaticPaths = async () => ({
	paths: [],
	fallback: "blocking",
});

export const getStaticProps = async ({ params: { slug } }) => {
	const props = await fetchProps(contentfulProps, slug, false);

	return props?.post
		? {
				props,
				revalidate: false,
		  }
		: { notFound: true };
};

export default ContenfulTutorialsApp;
